import { Provider } from '../interfaces';
import { TokenUtils } from '../utils';

const _provider_context = Symbol('_provider_context');

interface ProviderContext {
  current: Provider;
  providers: Provider[];
}

class ProviderGlobalContext {

  [_provider_context]: ProviderContext;

  init(providers: Provider[]): void {
    if (!providers) {
      return;
    }
    
    const { defaultProvider } = TokenUtils.getValues();
    
    const [current] = providers;
    const defaultProviderForAutocomplete =  providers.filter(provider => provider.nrSeqProvider == Number(defaultProvider)).shift(); 

    if(defaultProvider && defaultProviderForAutocomplete){
      this[_provider_context] = {
        current: defaultProviderForAutocomplete,
        providers,
      };
      return;
    }

    this[_provider_context] = {
      current,
      providers,
    };
  }

  isInitiated(): boolean {
    return Boolean(this[_provider_context]);
  }

  getSelectedProvider(): Provider {
    return this[_provider_context].current;
  }

  getProviders(): Provider[] {
    return this[_provider_context].providers;
  }

  setSelectedProvider(nrSeqProvider: number): void {
    const newCurrent = this.getProviders().find(provider => provider.nrSeqProvider === nrSeqProvider);

    if (!newCurrent) {
      return;
    }

    this[_provider_context] = {
      ...this[_provider_context],
      current: newCurrent,
    };
  }
}

const ProviderContext = new ProviderGlobalContext();

export {
  ProviderContext as default,
  Provider,
};
